import { getBrand } from "../brandResolver";

// Always same-origin: https(s)://<current-host>/api
const API_BASE = `${window.location.origin.replace(/\/$/, "")}/api`;

function buildUrl(endpoint = "", params = null) {
  const clean = String(endpoint || "").replace(/^\/+/, ""); // strip leading /
  const baseWithSlash = API_BASE.endsWith("/") ? API_BASE : API_BASE + "/";
  const url = new URL(clean, baseWithSlash);                // robust join

  if (params && typeof params === "object") {
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== null && v !== "") url.searchParams.append(k, v);
    }
  }
  return url;
}

async function fetchAPI(endpoint, method = "GET", params = null, data = null) {
  const headers = { brand: getBrand() }; // your tenant hint header

  const isForm = (typeof FormData !== "undefined") && (data instanceof FormData);
  const body = method !== "GET" ? (isForm ? data : (data ? JSON.stringify(data) : null)) : null;
  if (!isForm) headers["Content-Type"] = "application/json"; // don't set for FormData

  const url = buildUrl(endpoint, method === "GET" ? params : null);
  // Optional debug:
  // console.log("API →", url.toString(), { method, headers });

  try {
    const res = await fetch(url.toString(), { method, headers, body });
    if (!res.ok) {
  let errorData;

  try {
    errorData = await res.json();
  } catch {
    errorData = null;
  }

  const error = new Error(
    errorData?.message || "يوجد خطأ في اتصال الانترنت حاول مجددا لاحقا"
  );

  error.status = res.status;
  error.data = errorData;

  throw error;
}
    return res.json();
  } catch (err) {
    if (err.message === "Failed to fetch") throw new Error("فشل الاتصال بالخادم. أعد المحاولة لاحقًا.");
    console.error("خطأ:", err);
    throw err;
  }
}

const apiService = {
  // server mounts:
  // app.use("/api/forms", formsRoutes);
  // app.use("/api/upload", uploadsRoutes);
  uploadFiles:  (formData) => fetchAPI("upload/salla.forms", "POST", null, formData),
  submitFormData: (data)   => fetchAPI("forms/submit-form", "POST", null, data),
};

export default apiService;
